
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIntegrationVesselSelector as ObcIntegrationVesselSelectorElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-vessel-selector/integration-vessel-selector.js';
 
 
 

 
 export const ObcIntegrationVesselSelector = createComponent({
   react: React,
   tagName: 'obc-integration-vessel-selector',
   elementClass: ObcIntegrationVesselSelectorElement,
   events: {
     
   }
  });
 
 